import { createContext } from 'react'
import { UserType } from '../../api/auth-api'

export interface AuthContextType {
  userType: UserType | null
  isLoading: boolean
  error: string | null
}

const initialAuthContext: AuthContextType = {
  userType: null,
  isLoading: true,
  error: null,
}

export const AuthContext = createContext<AuthContextType>(initialAuthContext)
